import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  titlePageHebrew: string = "חניונים אוטונומיים | שקמה ידע וטכנולוגיה בע&quot;מ | חולון";
  titlePageEnglish: string = "Shikma N&T";
  languages = LANGUAGES;
  selectedLanguage;
  public isCollapsed: boolean = true;
  private toggleButton: any;
  private sidebarVisible: boolean;
  mobile_menu_visible: any = 0;
  isOpen: boolean = false;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private titleService: Title) { }

  ngOnInit() {
    this.selectedLanguage = this.languages.find((language) => language.code === this.translateService.currentLang);	
    this.translateService.use(this.selectedLanguage.code);
    this.selectLanguage(this.selectedLanguage);
  }
  
  navigateToLogin(){
    this.router.navigate(['/auth/login']);
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    var navbar = document.getElementsByClassName('navbar')[0];
      if (window.innerWidth < 993 && !this.isCollapsed) {
        navbar.classList.add('bg-white');
        navbar.classList.remove('navbar-transparent');
      } else {
        navbar.classList.remove('bg-white');
        navbar.classList.add('navbar-transparent');
      }
  };

  toggleNavbar(){
    this.isOpen = !this.isOpen;
    let navbarIsOpen = document.getElementsByClassName("navbar-nav")[1];

    if(this.isOpen){
        navbarIsOpen.setAttribute("style", "display: none;")
    }else{
      navbarIsOpen.setAttribute("style", "display: block;")
    }
  }
  
  sidebarClose() {
    const html = document.getElementsByTagName("html")[0];
    this.toggleButton.classList.remove("toggled");
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );

    if (window.innerWidth < 991) {
      setTimeout(function() {
        mainPanel.style.position = "";
      }, 500);
    }
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
  }

  navigateToPrivacyPolicy(){
    this.router.navigate(['auth/privacy-policy']);
  }

  selectLanguage(language: Language) {
		this.selectedLanguage = language;
    this.translateService.use(language.code);
    
    if(language.flagCode === "il"){
      this.setTitle(this.titlePageHebrew);

      let paragraphs = document.getElementsByTagName("p");      
      let navbar = document.getElementsByClassName('navbar')[0];
      let descriptionParagraphs = document.getElementsByClassName("bottom-right-text");
      let languageItems = document.getElementsByClassName("dropdown-item");
      let titleParagraphs = document.getElementsByClassName("top-right-text");
      let bodyFontStyles = document.getElementsByTagName("body")[0];
      let menuItem = document.getElementsByClassName("five-item")[0];
      let dropdownMenu = document.getElementsByClassName("dropdown-menu")[0];
      
      dropdownMenu.setAttribute("style", "right: -86px;");      
      menuItem.setAttribute("style", "margin-right:0px;");      
      bodyFontStyles.setAttribute("style", "font-family: Barlow, sans-serif;");
      navbar.setAttribute("style", "direction: rtl;");

      for (let i = 0; i < titleParagraphs.length; i++) {
        titleParagraphs[i].setAttribute("style", "text-align:right;")
      }
      if(languageItems){
        for (let i = 0; i < languageItems.length; i++) {
          languageItems[i].setAttribute("style", "justify-content: center;")
        }
      }

      for (let i = 0; i < descriptionParagraphs.length; i++) {
        descriptionParagraphs[i].setAttribute("style", "float:right; width:70%;")

      }
      for (let i = 0; i < paragraphs.length; i++) {
        paragraphs[i].setAttribute("style", "text-align:right;")
      }

      window.addEventListener("resize", this.updateColor);
      this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
      this.router.events.subscribe(event => {
        this.sidebarClose();
        var $layer: any = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
          this.mobile_menu_visible = 0;
        }
      });
      // on this page, we need on the body tag the classes .rtl and .menu-on-right
      var rtl = document.getElementsByClassName("rtl");
      var menuOnRight = document.getElementsByClassName("menu-on-right");
      if(!rtl && !menuOnRight){
        document.body.classList.add("rtl", "menu-on-right");
      }
     
      // we also need the rtl bootstrap
      // so we add it dynamically to the head
      let rtlIdElement = document.getElementById("rtl-id");
      if(!rtlIdElement){
          let head = document.head;
          let link = document.createElement("link");
          link.type = "text/css";
          link.rel = "stylesheet";
          link.id = "rtl-id";
          link.href =
            "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.css";
          head.appendChild(link);
      }
    }else{
      this.setTitle(this.titlePageEnglish);
      
      let paragraphs = document.getElementsByTagName("p");
      let descriptionParagraphs = document.getElementsByClassName("bottom-right-text");
      let titleParagraphs = document.getElementsByClassName("top-right-text");
      let bodyFontStyles = document.getElementsByTagName("body");
      let navbar = document.getElementsByClassName('navbar')[0];
      let dropdownMenu = document.getElementsByClassName("dropdown-menu")[0];
      dropdownMenu.setAttribute("style", "right: 0px;");     
      bodyFontStyles[0].setAttribute("style", "font-family: Poppins!important");
      navbar.setAttribute("style", "direction: ltl;");

      for (let i = 0; i < titleParagraphs.length; i++) {
        titleParagraphs[i].setAttribute("style", "text-align:left;")
      }
      
      for (let i = 0; i < paragraphs.length; i++) {
        if(i === 3){
          paragraphs[i].setAttribute("style", "text-align:center;")
        }else{
          paragraphs[i].setAttribute("style", "text-align:left;")
        }
      }

      for (let i = 0; i < descriptionParagraphs.length; i++) {
        descriptionParagraphs[i].setAttribute("style", "float:left;width:70%;")
      }
      // when we exit this page, we need to delete the classes .rtl and .menu-on-right
      // from the body tag
      let rtlIdElement = document.getElementById("rtl-id");
      if(rtlIdElement) {
        document.body.classList.remove("rtl", "menu-on-right");
        // we also need to delete the rtl bootstrap, so it does not break the other pages
        // that do not make use of rtl
        document.getElementById("rtl-id").remove();
      }
    }
  }
  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
}

export interface Language {
	flagCode: string;
	code: string;
	fullName: string;
}

export const LANGUAGES: Language[] = [
	{
		flagCode: 'il',
		code: 'il',
		fullName: 'Hebrew'
  },
  {
		flagCode: 'us',
		code: 'en',
		fullName: 'English'
	}
];

